import { styled, Typography, TypographyProps } from '@mui/material';

const TruncatedTypography = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const TruncatedTypographySpan = (props: TypographyProps) => {
  return <TruncatedTypography component="span" color="inherit" variant="inherit" {...props} />;
};
